import React, { useState, useEffect } from 'react';
import './User.css';
import userPhoto from './../../images/user-photo.jpg';
import eventsCountIcon from './../../images/events-count.svg';
import axios from 'axios';

import userAvatar from './../../images/unkonowprofile.jpg';

const User = ({
    translations,
    userLang,
    setCurrentPage,
    isShowUserButtons,
    setIsShowUserButtons,
    isShowUserRecommend,
    setIsShowUserRecommend,
    isShowUserNotifications,
    setIsShowUserNotifications,
    isFullScreenMode,
}) => {
    // данные об аккаунте
    const [userInfo, setUserInfo] = useState([]);
    const [recommendList, setRecommendList] = useState([]);
    const [notificationsList, setNotificationsList] = useState([]);
    const [notificationsCount, setNotificationsCount] = useState(0);

    const [currentPagginationPage, setCurrentPagginationPage] = useState(1);

    const notificationsCountLoading = async () => {
        try {
            const response = await axios.get(
                'https://mepointserver.ru/events/request/active/count',
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            'authToken'
                        )}`,
                    },
                }
            );
            if (response.data.success) {
                setNotificationsCount(response.data.result);
            }
        } catch (error) {
            console.error(
                'Ошибка получения числа активных уведомлений ',
                error
            );
        }
    };

    useEffect(() => {
        notificationsCountLoading();
    }, []);

    // запрос данных об аккаунте
    useEffect(() => {
        const handleUserClick = async () => {
            try {
                const response = await axios.get(
                    'https://mepointserver.ru/user/profile',
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                'authToken'
                            )}`,
                        },
                    }
                );
                if (response.data.success) {
                    setUserInfo(response.data.result);
                    console.log('Данные об аккаунте: ', response.data.result);
                }
            } catch (error) {
                console.error('Ошибка получения данных о пользователе ', error);
            }
        };
        handleUserClick();
    }, []);

    // запрос рекомендаций
    const loadingRecommend = async () => {
        try {
            const response = await axios.get(
                'https://mepointserver.ru/user/ads',
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            'authToken'
                        )}`,
                        'Accept-Language': userLang,
                    },
                }
            );
            if (response.data.success) {
                setRecommendList(response.data.result);
            }
        } catch (error) {
            console.error('Ошибка получения рекомендаций');
        }
    };

    useEffect(() => {
        if (isShowUserRecommend) {
            loadingRecommend();
        }
    }, [isShowUserRecommend]);

    // запрос уведомлений
    const handleNotificationsLoading = async () => {
        try {
            const response = await axios.get(
                'https://mepointserver.ru/events/requests',
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            'authToken'
                        )}`,
                        'Accept-Language': userLang,
                    },
                    params: {
                        page: currentPagginationPage,
                    },
                }
            );

            if (response.data.success) {
                console.log('Уведомления: ', response.data.result);
                setNotificationsList(response.data.result);
            }
        } catch (error) {
            console.error('Ошибка при получении уведомлений ', error);
        }
    };

    useEffect(() => {
        if (isShowUserNotifications) {
            handleNotificationsLoading();
        }
    }, [isShowUserNotifications, currentPagginationPage]);

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= Math.ceil(notificationsList.item2 / 15)) {
            setCurrentPagginationPage(newPage);
        }
    };

    // форматирование даты
    const formatDate = (chatDate) => {
        const date = new Date(chatDate);
        const timeZoneOffset = new Date().getTimezoneOffset();
        const localDate = new Date(date.getTime() - timeZoneOffset * 60 * 1000);

        const day = localDate.getDate().toString().padStart(2, '0');
        const month = (localDate.getMonth() + 1).toString().padStart(2, '0');
        const hours = localDate.getHours().toString().padStart(2, '0');
        const minutes = localDate.getMinutes().toString().padStart(2, '0');

        return `${day}.${month} ${hours}:${minutes}`;
    };

    // кнопка реклама
    const handleRecommendBtnClick = () => {
        setIsShowUserButtons(false);
        setIsShowUserRecommend(true);
    };

    // кнопка уведомления
    const handleNotificationsBtnClick = () => {
        setIsShowUserButtons(false);
        setIsShowUserNotifications(true);
    };

    // добавить рекомендацию
    const handleAddRecommendClick = () => {
        setCurrentPage('AddRecommendPage');
    };

    // удалить рекомендацию
    const handleDelClick = async (recommend) => {
        const isConfirmed = window.confirm(translations.confirmDeleteRecommend);

        if (isConfirmed) {
            try {
                const response = await axios.get(
                    'https://mepointserver.ru/user/ad/remove',
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                'authToken'
                            )}`,
                        },
                        params: {
                            id: recommend.id,
                        },
                    }
                );

                if (response.data.success) {
                    await loadingRecommend();
                }
            } catch (error) {
                console.error('Ошибка удаления рекомендации ', error);
            }
        }
    };

    // кнопка оплаты
    const getInvoiceLink = async (recommend) => {
        try {
            const response = await axios.get(
                'https://mepointserver.ru/user/ad/payment',
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            'authToken'
                        )}`,
                    },
                    params: {
                        adId: recommend.id,
                    },
                }
            );

            if (response.data.success) {
                console.log(response.data.result);
                alert('Для оплаты рекомендации перейдите в чат с ботом');
                window.Telegram.WebApp.close();
            }
        } catch (error) {
            console.error('Ошибка при получении ссылки на счет ', error);
        }
    };

    // кнопка "принять"
    const handleAcceptClick = async (notification) => {
        try {
            const response = await axios.get(
                'https://mepointserver.ru/events/request/confirm',
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            'authToken'
                        )}`,
                    },
                    params: {
                        id: notification.id,
                    },
                }
            );

            if (response.data.success) {
                console.log('Пользователь принят');
                handleNotificationsLoading();
                notificationsCountLoading();
            }
        } catch (error) {
            console.error('Ошибка принятия уведомления ', error);
        }
    };

    // кнопка "отклонить"
    const handleRejectClick = async (notification) => {
        try {
            const response = await axios.get(
                'https://mepointserver.ru/events/request/decline',
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            'authToken'
                        )}`,
                    },
                    params: {
                        id: notification.id,
                    },
                }
            );

            if (response.data.success) {
                console.log('Пользователь отклонен');
                handleNotificationsLoading();
                notificationsCountLoading();
            }
        } catch (error) {
            console.error('Ошибка отклонения уведомления ', error);
        }
    };

    const handleUserNameClick = (user) => {
        const username = `@${user.userName}`;
        window.Telegram.WebApp.openTelegramLink(`https://t.me/${username}`);
    };

    return (
        <div className='user__container'>
            <div
                className={isFullScreenMode ? 'user__info_full' : 'user__info'}
            >
                <img
                    className='user__photo'
                    src={
                        userInfo.avatarLink
                            ? `https://mepointserver.ru${userInfo.avatarLink}`
                            : userAvatar
                    }
                />
                <div className='user__about'>
                    <h3 className='user__name'>{userInfo.name}</h3>
                    <div className='user__events'>
                        <h3 className='user__events_count'>
                            {userInfo.activeEvents}
                        </h3>
                        <img
                            className='user__events_icon'
                            src={eventsCountIcon}
                        />
                    </div>
                </div>
                <p className='user__link'>
                    {userInfo.userName ? `@${userInfo.userName}` : ''}
                </p>
            </div>
            {isShowUserButtons && (
                <div className='user__buttons'>
                    <div
                        className='user__button'
                        onClick={handleRecommendBtnClick}
                    >
                        {translations.advertising}
                    </div>
                    <div
                        className='user__button'
                        onClick={handleNotificationsBtnClick}
                    >
                        {translations.notifications}{' '}
                        {notificationsCount !== 0 && `(${notificationsCount})`}
                    </div>
                </div>
            )}
            {isShowUserNotifications && (
                <div className='user__panel'>
                    <div className='user__panel_notification'>
                        {translations.notificationsTitle}
                    </div>
                    <div className='user__notification_items'>
                        {notificationsList.item2 > 0 &&
                            notificationsList.item1.map((notification) => (
                                <div
                                    className='user__notification_item'
                                    key={notification.id}
                                >
                                    <div className='user__notification_main'>
                                        <div className='user__notification_image'>
                                            <img
                                                src={
                                                    notification.userAvatar
                                                        ? `https://mepointserver.ru${notification.userAvatar}`
                                                        : userAvatar
                                                }
                                                alt={notification.userName}
                                            />
                                        </div>
                                        <div className='user__notification_info'>
                                            {notification.userName && (
                                                <p
                                                    onClick={() =>
                                                        handleUserNameClick(
                                                            notification
                                                        )
                                                    }
                                                >
                                                    {notification.userName}
                                                </p>
                                            )}
                                            <p>{notification.eventName}</p>
                                            <p>
                                                {formatDate(
                                                    notification.eventStart
                                                )}
                                            </p>
                                        </div>
                                    </div>

                                    {notification.confirmState === 'None' && (
                                        <div className='user__notification_btns'>
                                            <div
                                                className='user__recommend_info_btn'
                                                onClick={() =>
                                                    handleAcceptClick(
                                                        notification
                                                    )
                                                }
                                            >
                                                {translations.acceptUser}
                                            </div>

                                            <div
                                                className='user__recommend_info_btn'
                                                onClick={() =>
                                                    handleRejectClick(
                                                        notification
                                                    )
                                                }
                                            >
                                                {translations.rejectUser}
                                            </div>
                                        </div>
                                    )}
                                    {notification.confirmState ===
                                        'Confirm' && (
                                        <div className='user__notification_confirm'>
                                            {translations.isAcceptUser}
                                        </div>
                                    )}
                                    {notification.confirmState ===
                                        'Decline' && (
                                        <div className='user__notification_decline'>
                                            {translations.isRejectUser}
                                        </div>
                                    )}
                                </div>
                            ))}
                    </div>
                    <div className='user__notification_paggination'>
                        {notificationsList.item2 > 0 && (
                            <div className='notification__paggination_items'>
                                <button
                                    onClick={() =>
                                        handlePageChange(
                                            currentPagginationPage - 1
                                        )
                                    }
                                >
                                    {translations.previousPage}
                                </button>
                                <p>
                                    {currentPagginationPage} из{' '}
                                    {Math.ceil(notificationsList.item2 / 15)}
                                </p>
                                <button
                                    onClick={() =>
                                        handlePageChange(
                                            currentPagginationPage + 1
                                        )
                                    }
                                >
                                    {translations.NextPage}
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            )}
            {isShowUserRecommend && (
                <div className='user__panel'>
                    <div
                        className='user__panel_btn'
                        onClick={handleAddRecommendClick}
                    >
                        {translations.addRecommend}
                    </div>
                    {recommendList.length > 0 &&
                        recommendList.map((recommend) => (
                            <div
                                className='user__recommend_info'
                                key={recommend.id}
                            >
                                <div className='user__recommend_info_items'>
                                    <div className='user__recommend_info_image'>
                                        <img
                                            src={`https://mepointserver.ru${recommend.image}`}
                                        />
                                    </div>
                                    <p>
                                        {translations.nameRec} {recommend.name}
                                    </p>
                                    <p>
                                        {translations.addressRec}{' '}
                                        {recommend.address}
                                    </p>
                                    <p>
                                        {translations.categoryRec}{' '}
                                        {recommend.eventSubCategoryName}
                                    </p>
                                    <p>
                                        {translations.dataRec}{' '}
                                        {formatDate(recommend.start)} -{' '}
                                        {formatDate(recommend.end)}
                                    </p>
                                    <p>
                                        {translations.statusRec}{' '}
                                        {recommend.status}
                                    </p>
                                    <p>
                                        {translations.payRec}{' '}
                                        {recommend.paymentStatus}
                                    </p>
                                </div>
                                <div className='user__recommend_info_btns'>
                                    {(recommend.paymentStatus === 'Wait' ||
                                        recommend.paymentStatus ===
                                            'Canceled') && (
                                        <div
                                            className='user__recommend_info_btn'
                                            onClick={() =>
                                                getInvoiceLink(recommend)
                                            }
                                        >
                                            {translations.paidRecommend}
                                        </div>
                                    )}
                                    <div
                                        className='user__recommend_info_btn'
                                        onClick={() =>
                                            handleDelClick(recommend)
                                        }
                                    >
                                        {translations.delRecommend}
                                    </div>
                                </div>
                            </div>
                        ))}
                </div>
            )}
        </div>
    );
};

export default User;
